<div class="page-container">
    <div class="page-header">
        <button class="btn-back" (click)="location.back()">
            <mat-icon>arrow_back</mat-icon>
            <span>Back to Drivers</span>
        </button>
        <div class="header-content">
            <h1 class="page-title">{{ isEdit === 'true' ? 'Edit Driver' : 'New Driver Registration' }}</h1>
            <p class="page-subtitle">{{ isEdit === 'true' ? 'Update driver information and documents' : 'Add a new driver to your roster' }}</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">{{ isEdit === 'true' ? 'Updating driver...' : 'Registering driver...' }}</p>
    </div>

    <div class="form-card" [class.loading]="isLoading">
        <!-- Personal Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>person</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Personal Information</h2>
                    <p>Basic driver details</p>
                </div>
            </div>

            <div class="form-grid" style="grid-template-columns: 1fr 1fr 1fr;">
                <div class="form-group">
                    <label class="form-label">Khmer Name</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">person</mat-icon>
                        <input matInput [(ngModel)]="khmerName" placeholder="Enter Khmer name" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">English Name</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">person</mat-icon>
                        <input matInput [(ngModel)]="englishName" placeholder="Enter English name" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Date of Birth</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">cake</mat-icon>
                        <input matInput [(ngModel)]="dateOfBirth" [matDatepicker]="dobPicker" placeholder="Select date" (dateChange)="onDobChange($event)" />
                        <mat-datepicker-toggle matIconSuffix [for]="dobPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dobPicker></mat-datepicker>
                    </mat-form-field>
                    <span *ngIf="age !== null" class="age-badge">{{ age }} years old</span>
                </div>
            </div>

            <div class="form-grid" style="grid-template-columns: 1fr 2fr;">
                <div class="form-group">
                    <label class="form-label">Join Date</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">event_available</mat-icon>
                        <input matInput [(ngModel)]="joinDate" [matDatepicker]="joinPicker" placeholder="Select date" />
                        <mat-datepicker-toggle matIconSuffix [for]="joinPicker"></mat-datepicker-toggle>
                        <mat-datepicker #joinPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Current Address</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">home</mat-icon>
                        <input matInput [(ngModel)]="currentAddress" placeholder="Enter current address" />
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid" style="grid-template-columns: 1fr 1fr;">
                <div class="form-group">
                    <label class="form-label">Gender</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">wc</mat-icon>
                        <mat-select [(ngModel)]="selectedGender" placeholder="Select gender">
                            <mat-option *ngFor="let option of genderOption" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Marital Status</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">favorite</mat-icon>
                        <mat-select [(ngModel)]="selectedMaritalStatus" placeholder="Select marital status">
                            <mat-option *ngFor="let option of maritalStautsOption" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Driver Picture</label>
                <div class="image-upload-container">
                    <input
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        (change)="onSelecteDriverPicFile($event)"
                        #driverPicInput
                        style="display: none"
                    />
                    <button type="button" class="btn-upload" (click)="driverPicInput.click()">
                        <mat-icon>cloud_upload</mat-icon>
                        <span>Choose Image</span>
                    </button>
                    <span class="upload-hint">Only images allowed: (.png, .jpg, .jpeg)</span>
                    <div *ngIf="driverPicture" class="image-preview">
                        <img [src]="getImageUrl(driverPicture)" alt="Driver Preview" />
                    </div>
                </div>
            </div>
        </div>

        <!-- National ID Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>badge</mat-icon>
                </div>
                <div class="section-title">
                    <h2>National ID</h2>
                    <p>National identification card details</p>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">NID Number</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">badge</mat-icon>
                        <input matInput [(ngModel)]="NIDNumber" placeholder="Enter NID number" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Expired Date</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">calendar_today</mat-icon>
                        <input matInput [(ngModel)]="NIDExpiredDate" [matDatepicker]="nidPicker" placeholder="Select date" />
                        <mat-datepicker-toggle matIconSuffix [for]="nidPicker"></mat-datepicker-toggle>
                        <mat-datepicker #nidPicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">NID Picture</label>
                <div class="image-upload-container">
                    <input
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        (change)="onSelecteNIDPicFile($event)"
                        #nidPicInput
                        style="display: none"
                    />
                    <button type="button" class="btn-upload" (click)="nidPicInput.click()">
                        <mat-icon>cloud_upload</mat-icon>
                        <span>Choose Image</span>
                    </button>
                    <span class="upload-hint">Only images allowed: (.png, .jpg, .jpeg)</span>
                    <div *ngIf="nidPicture" class="image-preview">
                        <img [src]="getImageUrl(nidPicture)" alt="NID Preview" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Driver License Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>credit_card</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Driver License</h2>
                    <p>Driver license information</p>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Driver License Number</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">credit_card</mat-icon>
                        <input matInput [(ngModel)]="driverLicenseNumber" placeholder="Enter license number" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Expired Date</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">calendar_today</mat-icon>
                        <input matInput [(ngModel)]="driverLicenseExpireDate" [matDatepicker]="licensePicker" placeholder="Select date" />
                        <mat-datepicker-toggle matIconSuffix [for]="licensePicker"></mat-datepicker-toggle>
                        <mat-datepicker #licensePicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Driver License Picture</label>
                <div class="image-upload-container">
                    <input
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        (change)="onSelectedDriverLicenseFile($event)"
                        #licensePicInput
                        style="display: none"
                    />
                    <button type="button" class="btn-upload" (click)="licensePicInput.click()">
                        <mat-icon>cloud_upload</mat-icon>
                        <span>Choose Image</span>
                    </button>
                    <span class="upload-hint">Only images allowed: (.png, .jpg, .jpeg)</span>
                    <div *ngIf="driveLicensePicture" class="image-preview">
                        <img [src]="getImageUrl(driveLicensePicture)" alt="License Preview" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Criminal Record Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>description</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Supported Documents</h2>
                    <p>Upload Supported Documents</p>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Supported Documents</label>
                <div class="image-upload-container">
                    <input
                        type="file"
                        accept=".png, .jpg, .jpeg, .pdf"
                        multiple
                        (change)="onSelectedSupportDocFiles($event)"
                        #supportDocInput
                        style="display: none"
                    />
                    <button type="button" class="btn-upload" (click)="supportDocInput.click()">
                        <mat-icon>cloud_upload</mat-icon>
                        <span>Choose Documents</span>
                    </button>
                    <span class="upload-hint">Allowed: images (.png, .jpg, .jpeg) and PDF (.pdf)</span>
                    <div *ngIf="supportDocFiles.length > 0" class="doc-preview-grid">
                        <div *ngFor="let file of supportDocFiles; let i = index" class="doc-preview-item" (click)="viewDocument(file)">
                            <ng-container *ngIf="isPdf(file); else imgPreview">
                                <div class="pdf-preview">
                                    <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
                                    <span class="pdf-name">{{ file.name }}</span>
                                </div>
                            </ng-container>
                            <ng-template #imgPreview>
                                <img [src]="getImageUrl(file)" [alt]="file.name" />
                            </ng-template>
                            <div class="doc-overlay">
                                <mat-icon>{{ isPdf(file) ? 'open_in_new' : 'zoom_in' }}</mat-icon>
                            </div>
                            <button type="button" class="btn-remove-doc" (click)="removeSupportDoc(i); $event.stopPropagation()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>

                    <!-- Document Viewer -->
                    <div *ngIf="lightboxFile" class="lightbox-overlay" (click)="closeLightbox()">
                        <div class="lightbox-content" [class.lightbox-pdf]="isPdf(lightboxFile)" (click)="$event.stopPropagation()">
                            <button type="button" class="lightbox-close" (click)="closeLightbox()">
                                <mat-icon>close</mat-icon>
                            </button>
                            <ng-container *ngIf="isPdf(lightboxFile); else lightboxImg">
                                <iframe [src]="lightboxUrl" class="pdf-viewer" frameborder="0"></iframe>
                            </ng-container>
                            <ng-template #lightboxImg>
                                <img [src]="getImageUrl(lightboxFile)" [alt]="lightboxFile.name" />
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Contact Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>phone</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Contact Information</h2>
                    <p>Phone numbers and emergency contacts</p>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Contact Numbers</label>
                <form [formGroup]="phoneForm">
                    <div formArrayName="phoneNumbers" class="phone-list">
                        <div *ngFor="let phone of phoneNumbers.controls; let i = index" [formGroupName]="i" class="phone-row">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-icon matPrefix class="field-icon">phone</mat-icon>
                                <input matInput formControlName="number" placeholder="Phone number" appPhoneFormat />
                            </mat-form-field>
                            <button type="button" class="contact-btn contact-btn-remove" *ngIf="phoneNumbers.length > 1" (click)="removePhoneNumber(i)">
                                <mat-icon>remove</mat-icon>
                            </button>
                        </div>
                    </div>
                    <button type="button" class="contact-btn-add-new" (click)="addPhoneNumber()">
                        <mat-icon>add</mat-icon>
                        <span>Add Phone Number</span>
                    </button>
                </form>
            </div>

            <div class="form-group">
                <label class="form-label">Emergency Contact Number</label>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-icon matPrefix class="field-icon">phone_in_talk</mat-icon>
                    <input matInput [(ngModel)]="emergencyContactNumber" placeholder="Enter emergency contact" appPhoneFormat />
                </mat-form-field>
            </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="location.back()">
                Cancel
            </button>
            <button type="submit" class="btn-primary" (click)="submitButtonAction()">
                <mat-icon>{{ isEdit === 'true' ? 'save' : 'person_add' }}</mat-icon>
                <span>{{ isEdit === 'true' ? 'Update Driver' : 'Register Driver' }}</span>
            </button>
        </div>
    </div>
</div>
